import { BLOCK_CLASSES as t } from "../../constants.js";
const o = {
  defining: !0,
  content: "paragraph | heading | subheading | subheading3 | subheading4 | codeBlock",
  attrs: {
    type: { default: "collapsibleSectionSummary" }
  },
  parseDOM: [
    {
      tag: "summary"
    }
  ],
  toDOM() {
    return ["summary", 0];
  }
}, a = {
  defining: !0,
  content: "(block|list|table)+",
  attrs: {
    type: { default: "collapsibleSectionContent" }
  },
  parseDOM: [
    {
      tag: `div.${t.collapsibleSectionContent}`
    }
  ],
  toDOM() {
    return ["div", { class: t.collapsibleSectionContent }, 0];
  }
}, i = {
  inline: !1,
  defining: !0,
  content: "collapsibleSectionSummary collapsibleSectionContent",
  group: "block",
  attrs: {
    type: { default: "collapsibleSection" },
    open: { default: !0 }
  },
  parseDOM: [
    {
      tag: "details"
    }
  ],
  toDOM(e) {
    return ["details", e.attrs.open ? { open: "true" } : {}, 0];
  }
};
export {
  a as collapsibleSectionContentSpec,
  i as collapsibleSectionSpec,
  o as collapsibleSectionSummarySpec
};
